import { TenantTierEnum } from "@finway-group/shared/lib/models/featureFlags/tenantTier.enum"
import React from "react"

import Tier1Icon from "Components/icons/TIER_1"
import Tier2Icon from "Components/icons/TIER_2"

export type TenantTierPaidEnum = Exclude<TenantTierEnum, TenantTierEnum.FREE>

interface TierIconInterface {
    tier: TenantTierPaidEnum
}

const TierIcon: React.FC<TierIconInterface> = ({ tier }) => {
    switch (tier) {
        case TenantTierEnum.TIER_1:
            return <Tier1Icon />
        case TenantTierEnum.TIER_2:
            return <Tier2Icon />
    }
}

export default TierIcon
